function elementScrollTo(element, left, behavior) {
  requestAnimationFrame(() => {
    element.scrollTo({
      left: left,
      top: 0,
      behavior: behavior ? behavior : Themu.prefersReducedMotion ? 'instant' : 'smooth',
    });
  });
}

function removeTrapBodyScroll() {
  const scrollY = document.body.style.top;

  document.body.style.paddingRight = '';
  document.body.style.overflow = 'visible';
  document.body.style.touchAction = '';

  document.body.style.top = '';

  if (scrollY === '') {
    return;
  }

  window.scrollTo(0, parseInt(scrollY || '0') * -1);

  setTimeout(() => {
    document.dispatchEvent(new Event('ce-sticky-scroll-header:unfreeze'));
  }, 100);
}

function trapBodyScroll() {
  document.dispatchEvent(new Event('ce-sticky-scroll-header:freeze'));

  document.body.style.top = `-${window.scrollY}px`;

  document.body.style.paddingRight = `${window.innerWidth - document.body.offsetWidth}px`;
  document.body.style.overflow = 'hidden';
  document.body.style.touchAction = 'none';
}

(function () {
  window.Themu = window.Themu || {};

  function mediaQueryIsViewportDesktop() {
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    mediaQuery.addEventListener('change', () => {
      Themu.isViewportDesktop = mediaQuery.matches;
    });

    return mediaQuery;
  }

  function mediaQueryPrefersReducedMotion() {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    mediaQuery.addEventListener('change', () => {
      Themu.prefersReducedMotion = mediaQuery.matches;
    });

    return mediaQuery;
  }

  window.Themu = {
    ...window.Themu,
    ...{
      animation: {
        easeIn: 'cubic-bezier(0, 0, 0.2, 1)',
        easeOut: 'cubic-bezier(0.4, 0, 1, 1)',
      },
      prefersReducedMotion: mediaQueryPrefersReducedMotion().matches,
      isViewportDesktop: mediaQueryIsViewportDesktop().matches,
    },
  };

  document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
})();
;(() => {
  /* =====================================================
     PRODUCT CARD – Quantity + AJAX Add to Cart + Toast + REAL Section Refresh (Arabica)
     - Count & cart drawer update without page reload
     - Refreshes the actual sections present on the current page
     ===================================================== */

  const clampQty = (v) => {
    const n = parseInt(v, 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  };

  const findQtyInput = (el) => {
    const root = el.closest(".pc-actions") || el.closest(".product-card") || document;
    return root.querySelector("[data-quantity-input]") || root.querySelector('input[name="quantity"]');
  };

  const findVariantId = (btn) => {
    const ce = btn.closest("ce-add-to-cart-button");
    const id = ce?.getAttribute("variant-id");
    return id ? String(id) : null;
  };

  const setLoading = (btn, state) => {
    btn.disabled = state;
    btn.setAttribute("aria-busy", state ? "true" : "false");
    btn.style.opacity = state ? "0.7" : "";
  };

  const addToCart = async (variantId, qty) => {
    const body = new URLSearchParams();
    body.set("id", variantId);
    body.set("quantity", String(qty));

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: body.toString(),
      credentials: "same-origin",
    });

    const text = await res.text().catch(() => "");
    if (!res.ok) throw new Error(`Add to cart failed: ${res.status} ${text}`);
    try { return JSON.parse(text); } catch { return text; }
  };

  const getCart = async () => {
    const res = await fetch("/cart.js", {
      headers: { "Accept": "application/json" },
      credentials: "same-origin",
    });
    return res.json();
  };

  /* =====================================================
     Toast (your bulletproof version)
     ===================================================== */
  const getToastContainer = () => {
    const existing =
      document.querySelector("[data-toasts]") ||
      document.querySelector("[data-toast-container]") ||
      document.querySelector("ce-toasts") ||
      document.querySelector(".toast-container");

    if (existing) return existing;

    let c = document.getElementById("pc-toast-container");
    if (!c) {
      c = document.createElement("div");
      c.id = "pc-toast-container";
      c.style.position = "fixed";
      c.style.right = "16px";
      c.style.bottom = "16px";
      c.style.zIndex = "999999";
      c.style.display = "flex";
      c.style.flexDirection = "column";
      c.style.gap = "12px";
      c.style.maxWidth = "360px";
      c.style.width = "calc(100% - 32px)";
      c.style.pointerEvents = "none";
      document.body.appendChild(c);
    }
    return c;
  };

  const showArabicaToast = (message, durationMs = 3000) => {
    const container = getToastContainer();

    const toast = document.createElement("ce-toast");
    toast.setAttribute("duration", String(durationMs));
    toast.setAttribute("offset", "-16px");
    toast.className =
      "bg-background block mb-4 opacity-0 pointer-events-auto pl-4 pr-11 py-4 relative rounded-other shadow-toast w-1/1";
    toast.style.pointerEvents = "auto";

    toast.innerHTML = `
      <output class="flex">
        <div class="flex-none pr-2">
          <div class="h-5 w-5">
            <svg viewBox="0 0 20 20" width="20">
              <use href="#icon-success-rounded"></use>
            </svg>
          </div>
        </div>
        <div class="flex-1 pl-2">
          <p class="text-body-text text-sm">${message}</p>
        </div>
      </output>
      <button class="button button--square absolute -right-0.5 top-0.5 px-4.5 text-body-text" data-toast-button-dismiss="">
        <svg viewBox="0 0 20 20" width="12">
          <use href="#icon-close-rounded"></use>
        </svg>
      </button>
    `;

    if (container.id === "pc-toast-container") toast.classList.remove("mb-4");
    container.appendChild(toast);

    requestAnimationFrame(() => {
      toast.style.transform = "translateY(0px)";
      toast.style.opacity = "1";
    });

    const dismissBtn = toast.querySelector("[data-toast-button-dismiss]");
    if (dismissBtn) {
      dismissBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        toast.style.opacity = "0";
        setTimeout(() => toast.remove(), 250);
      });
    }

    setTimeout(() => {
      toast.style.opacity = "0";
      setTimeout(() => toast.remove(), 250);
    }, durationMs);
  };

  /* =====================================================
     SECTION REFRESH (the important part)
     - Discover section handles present on the page: shopify-section-<handle>
     - Filter for relevant ones (header/cart/drawer)
     - Fetch /?sections=... and replace DOM wrappers
     ===================================================== */

  const discoverRelevantSectionHandles = () => {
    const nodes = Array.from(document.querySelectorAll('[id^="shopify-section-"]'));
    const handles = nodes
      .map((n) => n.id.replace("shopify-section-", "").trim())
      .filter(Boolean);

    const want = (h) => {
      const s = h.toLowerCase();
      // broad on purpose
      return (
        s.includes("header") ||
        s.includes("cart") ||
        s.includes("drawer") ||
        s.includes("mini") ||
        s.includes("announcement")
      );
    };

    // unique + relevant
    return Array.from(new Set(handles.filter(want)));
  };

  const fetchSections = async (handles) => {
    if (!handles.length) return null;

    const url = `/?sections=${encodeURIComponent(handles.join(","))}`;
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error("sections fetch failed");
    return res.json();
  };

  const replaceSectionWrapper = (handle, html) => {
    // Returned html typically includes the wrapper: <div id="shopify-section-...">
    const tpl = document.createElement("template");
    tpl.innerHTML = html;

    const newWrapper = tpl.content.querySelector(`#shopify-section-${CSS.escape(handle)}`) || tpl.content.firstElementChild;
    if (!newWrapper) return false;

    const current = document.querySelector(`#shopify-section-${CSS.escape(handle)}`);
    if (!current) return false;

    current.replaceWith(newWrapper);
    return true;
  };

  const refreshRelevantSections = async () => {
    try {
      const handles = discoverRelevantSectionHandles();
      const data = await fetchSections(handles);
      if (!data) return;

      handles.forEach((h) => {
        const html = data[h];
        if (typeof html === "string" && html.trim().length) {
          replaceSectionWrapper(h, html);
        }
      });
    } catch (e) {
      // silent fail; cart still added server-side
      console.warn("[pc] section refresh failed", e);
    }
  };

  /* =====================================================
     ALSO update a count fallback (if some themes don’t re-render header)
     ===================================================== */
  const updateCartCountFallback = (cart) => {
    const count = String(cart.item_count);
    const selectors = [
      "[data-cart-count]",
      "[data-cart-count-bubble]",
      ".cart-count",
      ".cart-count-bubble",
      ".header__cart-count",
      ".site-header__cart-count",
    ];
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        el.textContent = count;
        if (cart.item_count > 0) el.classList.remove("hidden");
        if (cart.item_count === 0) el.classList.add("hidden");
      });
    });
  };

  /* =====================
     1) Quantity +/- click
     ===================== */
  document.addEventListener(
    "click",
    (e) => {
      const plus = e.target.closest("[data-quantity-plus]");
      const minus = e.target.closest("[data-quantity-minus]");
      if (!plus && !minus) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      const input = findQtyInput(e.target);
      if (!input) return;

      let value = clampQty(input.value);
      if (plus) value += 1;
      if (minus) value = Math.max(1, value - 1);

      input.value = String(value);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    },
    true
  );

  /* =====================
     2) Add to cart click
     ===================== */
  document.addEventListener(
    "click",
    async (e) => {
      const btn = e.target.closest("button.pc-atc");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      const variantId = findVariantId(btn);
      const qtyInput = findQtyInput(btn);
      const qty = clampQty(qtyInput?.value);

      if (!variantId) return;

      try {
        setLoading(btn, true);
        await addToCart(variantId, qty);

        const cart = await getCart();

        // Fire theme-ish events
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
        document.dispatchEvent(new CustomEvent("cart:change", { detail: cart }));

        // Toast
        showArabicaToast("Produkt in den Warenkorb gelegt!", 3000);

        // Update count immediately (fallback)
        updateCartCountFallback(cart);

        // ✅ Most important: refresh header/cart/drawer sections
        await refreshRelevantSections();
      } catch (err) {
        console.error("Quick add failed", err);
        window.location.href = "/cart";
      } finally {
        setLoading(btn, false);
      }
    },
    true
  );
})();